import { useGetTwoFactorMethods } from '../../api/user/useGetTwoFactorMethods'
import { useDeleteTwoFactorAuthentication } from '../../api/auth/useDeleteTwoFactorAuthentication'
import { useEditDefaultTwoFactorMethod } from '../../api/user/useEditDefaultTwoFactorMethod'
import toast from 'react-hot-toast'
import { Accordion, AccordionItem, Button, Pill } from '@demandlocal/components'
import { match } from 'ts-pattern'
import TwoFactorSetup from '../TwoFactorSetup/TwoFactorSetup'
import React from 'react'
import { ReactComponent as TwoFactorSuccess } from '../../images/two_factor/two_factor_success.svg'

export default function EditUserTwoFactor() {
  const { data: twoFactorMethods, refetch: refetchTwoFactorMethods } =
    useGetTwoFactorMethods()
  const { mutateAsync: deleteTwoFactorAuthentication } =
    useDeleteTwoFactorAuthentication()

  const { mutateAsync: editDefaultTwoFactorMethod } = useEditDefaultTwoFactorMethod()
  const onDeleteTwoFactorAuthentication = async (
    type: 'sms' | 'authenticator',
  ): Promise<void> => {
    if (window.confirm('Are you sure you want to delete two factor authentication?')) {
      await deleteTwoFactorAuthentication(
        {
          type: type,
        },
        {
          onSuccess: async () => {
            await refetchTwoFactorMethods()
            toast.success('Two factor authentication deleted successfully')
          },
        },
      )
    }
  }
  return (
    <div>
      <div className={'pb-4'}>
        <Accordion className={'border-0'}>
          {twoFactorMethods?.map((method) => {
            return (
              <AccordionItem key={method.type} className={'py-4'}>
                <AccordionItem.Header>
                  <div className={'flex flex-row justify-between flex-1'}>
                    <h3 className={'font-bold text-sm'}>{method.label}</h3>
                    <div className={'flex flex-row items-center gap-2 pr-2'}>
                      {method.enabled && !method.default && (
                        <span
                          className={'text-xs font-bold'}
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            const toastId = toast.loading(
                              `Setting ${method.label} as default...`,
                            )
                            editDefaultTwoFactorMethod(
                              {
                                method: method.type,
                              },
                              {
                                onSuccess: () => {
                                  toast.success(`Set ${method.label} as default!`, {
                                    id: toastId,
                                  })
                                  refetchTwoFactorMethods()
                                },
                              },
                            )
                          }}>
                          Set as default
                        </span>
                      )}
                      {match(method.enabled)
                        .with(true, () => {
                          return (
                            <div className={'flex gap-2 items-center'}>
                              {method.default && (
                                <Pill type={method.default ? 'info-purple' : 'success'}>
                                  {method.default ? 'Default' : 'Enabled'}
                                </Pill>
                              )}
                              <Pill type={'success'}>Enabled</Pill>
                            </div>
                          )
                        })
                        .with(false, () => <Pill type={'error'}>Disabled</Pill>)
                        .otherwise(() => (
                          <Pill type={'warning'}>Unknown</Pill>
                        ))}
                    </div>
                  </div>
                </AccordionItem.Header>
                <AccordionItem.Body>
                  {method.enabled ? (
                    <div
                      className={
                        'flex flex-col items-center justify-center h-full gap-12'
                      }>
                      <TwoFactorSuccess />
                      <div className={'flex flex-col items-center gap-3'}>
                        <h1 className={'text-3xl font-bold text-primary-xiketic'}>
                          Two factor authentication enabled!
                        </h1>
                        <Button
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            onDeleteTwoFactorAuthentication(method.type)
                          }}>
                          Disable two factor authentication
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <TwoFactorSetup type={method.type} />
                  )}
                </AccordionItem.Body>
              </AccordionItem>
            )
          })}
        </Accordion>
      </div>
    </div>
  )
}
